module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-48267274-9","anonymize":true,"respectDNT":true},
    },{
      plugin: require('../node_modules/gatsby-plugin-theme-ui/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-mdx/gatsby-browser.js'),
      options: {"plugins":[],"extensions":[".mdx",".md"],"defaultLayouts":{"default":"/vercel/2a2ba5ce/node_modules/@undataforum/gatsby-theme-base/src/components/mdx-page.js"},"gatsbyRemarkPlugins":["gatsby-remark-smartypants"]},
    }]
